<template>
  <div v-if="isLoading" class="fixed inset-0 z-[9999] flex items-center justify-center bg-[var(--sf-bg)]/95 backdrop-blur-xl">
    <div class="flex flex-col items-center px-8 py-12 rounded-3xl bg-[var(--sf-surface)]/60 border border-[var(--sf-brand)]/20 shadow-2xl max-w-[90%] max-w-[400px] mx-auto">
      <!-- Spinner: 70px with 7px stroke, exact match to original -->
      <svg
        width="70"
        height="70"
        viewBox="0 0 24 24"
        fill="none"
        class="animate-spin text-[var(--sf-brand)] drop-shadow-[0_4px_8px_rgba(var(--sf-brand-rgb),0.3)]"
        role="status"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          stroke-opacity="0.2"
          stroke-width="7"
        />
        <path
          d="M12 3C7.02944 3 3 7.02944 3 12"
          stroke="currentColor"
          stroke-width="7"
          stroke-linecap="round"
        />
      </svg>
      <p class="loading-text mt-4 text-[var(--sf-text)] text-base font-medium text-center w-full break-words tracking-wide">
        {{ loadingMessage || 'Loading...' }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">


import { computed } from 'vue'
import { useUIStore } from '@/stores/useUIStore'

// Store
const uiStore = useUIStore()

// Computed
const isLoading = computed(() => uiStore.isAppLoading)
const loadingMessage = computed(() => uiStore.currentLoadingMessage)
</script>

<style scoped>
.loading-text {
  color: var(--sf-text);
  animation: pulse 2s infinite ease-in-out, shimmer 3s linear infinite;
  background: linear-gradient(
    90deg,
    var(--sf-text-muted) 0%,
    var(--sf-brand) 50%,
    var(--sf-text-muted) 100%
  );
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.02);
  }
}

@keyframes shimmer {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@media (max-width: 600px) {
  .loading-text {
    font-size: 0.95rem;
    margin-top: 1.25rem;
  }
}
</style>
